import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router';
import SubNavigationLayout from '../shared/navigation/SubNavigationLayout';
import TitleDropdown from '../shared/navigation/TitleDropdown';
import { LinkContainer } from '../shared/navigation/NavigationLinksContainer';
import { NavigationLink } from '../shared/navigation/NavigationLink';
import AgeCategorySelector from '../shared/common/AgeCategorySelector';
import ShopLanguageDropDown from '../shared/navigation/ShopLanguageDropDown';
import { useAgeCategorySearchParam } from '../shared/utils/useAgeCategorySearchParam';

type Props = {
    readonly isSticky: boolean;
    readonly shopLanguage?: string;
};

const LibxNavigation: FC<Props> = ({ isSticky, shopLanguage }) => {
    const { t } = useTranslation();
    const { url } = useRouteMatch();
    const { searchParam: ageCategorySearchParam } = useAgeCategorySearchParam();
    const searchParams = new URLSearchParams(ageCategorySearchParam ? { ageCategory: ageCategorySearchParam } : {});

    return (
        <SubNavigationLayout
            left={
                <>
                    {shopLanguage ? <ShopLanguageDropDown currentShopLanguage={shopLanguage} /> : null}
                    <TitleDropdown isLibx shopLanguage={shopLanguage} />
                </>
            }
            center={
                <LinkContainer>
                    <li>
                        <NavigationLink to={{ pathname: `${url}/featured`, search: searchParams.toString() }}>
                            {t('menu.shop.libxchange.featured')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to={{ pathname: `${url}/newlyadded`, search: searchParams.toString() }}>
                            {t('menu.shop.libxchange.newlyAdded')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to={{ pathname: `${url}/products`, search: searchParams.toString() }}>
                            {t('menu.shop.libxchange.allTitles')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to={{ pathname: `${url}/genres`, search: searchParams.toString() }}>
                            {t('menu.shop.libxchange.genres')}
                        </NavigationLink>
                    </li>
                    <li>
                        <NavigationLink to={{ pathname: `${url}/localregions`, search: searchParams.toString() }}>
                            {t('menu.shop.libxchange.localRegions')}
                        </NavigationLink>
                    </li>
                </LinkContainer>
            }
            right={!isSticky ? <AgeCategorySelector /> : null}
            isSticky={isSticky}
            width="30"
        />
    );
};

export default LibxNavigation;
